/* Velvet Bags — interaction layer */
(function () {
  'use strict';

  /* Horizon scrolls inside .page-wrapper, not the window. Find whichever
     element is actually doing the scrolling so observers and parallax work. */
  function scrollHost() {
    var candidates = ['.page-wrapper', '#MainContent'];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (!el) continue;
      var oy = getComputedStyle(el).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight + 4) return el;
    }
    return null;
  }

  function revealAll() {
    document.querySelectorAll('[data-vb-reveal]').forEach(function (el) {
      el.classList.add('vb-in');
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var targets = document.querySelectorAll('[data-vb-reveal]:not(.vb-armed)');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('vb-in'); });
      return;
    }

    targets.forEach(function (el) { el.classList.add('vb-armed'); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vb-in');
          io.unobserve(entry.target);
        }
      });
    }, { root: scrollHost(), rootMargin: '0px 0px -6% 0px', threshold: 0.06 });

    targets.forEach(function (el) { io.observe(el); });

    /* Safety net: never leave the page blank if the observer never fires. */
    setTimeout(function () {
      if (!document.querySelector('[data-vb-reveal].vb-in')) revealAll();
    }, 1200);
  }

  /* ---------- Hero parallax ---------- */
  function initParallax() {
    var layers = document.querySelectorAll('[data-vb-parallax]');
    if (!layers.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var host = scrollHost();
    var scroller = host || window;
    var ticking = false;

    function offset() {
      return host ? host.scrollTop : (window.pageYOffset || document.documentElement.scrollTop || 0);
    }

    function frame() {
      ticking = false;
      var y = offset();
      layers.forEach(function (el) {
        var parent = el.parentElement;
        if (!parent) return;
        var rect = parent.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > window.innerHeight + 200) return;
        var rate = parseFloat(el.getAttribute('data-vb-parallax')) || 0.14;
        el.style.transform = 'translate3d(0,' + (y * rate).toFixed(2) + 'px,0)';
      });
    }

    scroller.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(frame); }
    }, { passive: true });
    frame();
  }

  /* ---------- Marquee duplication ---------- */
  function initMarquee() {
    document.querySelectorAll('[data-vb-marquee]').forEach(function (track) {
      if (track.dataset.vbCloned === '1') return;
      track.dataset.vbCloned = '1';
      track.innerHTML += track.innerHTML;
    });
  }

  /* ---------- Toast ---------- */
  var toastEl = null, toastTimer = null;
  function toast(title, message, href, label) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'vb-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<b></b><p></p>' + (href ? '<a href="' + href + '"></a>' : '');
    toastEl.querySelector('b').textContent = title;
    toastEl.querySelector('p').textContent = message;
    if (href) toastEl.querySelector('a').textContent = label || 'View bag';

    /* Show on the next frame so the transition runs; a timer backs it up in
       case rAF is throttled (background tab, reduced power mode). */
    var show = function () { toastEl.classList.add('is-on'); };
    window.requestAnimationFrame(show);
    setTimeout(show, 30);

    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 5200);
  }

  /* ---------- Cart count refresh (best effort) ---------- */
  function refreshCartUI() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        ['.cart-bubble__text', '[ref="cartBubbleText"]', '.cart-count', '.header-actions__cart-count', '[data-cart-count]']
          .forEach(function (s) {
            document.querySelectorAll(s).forEach(function (n) { n.textContent = cart.item_count; });
          });
        document.querySelectorAll('.cart-bubble').forEach(function (n) {
          n.removeAttribute('hidden');
          n.classList.add('cart-bubble--visible');
        });
        ['cart:update', 'cart:refresh', 'cart:change'].forEach(function (name) {
          document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } }));
        });
      })
      .catch(function () {});
  }

  /* ---------- Add to bag from product cards ---------- */
  function initQuickAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches('[data-vb-add]')) return;
      e.preventDefault();
      var btn = form.querySelector('button');
      var original = btn ? btn.textContent : '';
      var title = form.getAttribute('data-vb-title') || 'Your bag';
      var idField = form.querySelector('[name="id"]');
      if (!idField) return;
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idField.value), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          toast('Added to bag', title, '/cart', 'View bag');
          refreshCartUI();
        })
        .catch(function () {
          toast('Not available', 'This piece could not be added right now.', '/cart', 'View bag');
        })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.textContent = original; }
        });
    });
  }

  function boot() {
    initReveal();
    initParallax();
    initMarquee();
    initQuickAdd();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    initReveal(); initParallax(); initMarquee();
  });
})();
